import { Input, Component } from '@angular/core';

@Component({
  selector: 'sx-tracking',
  templateUrl: './tracking.component.html',
})
export class TrackingComponent {
  @Input() progreso: any;
  @Input() creado: string;
  @Input() modificado: string;
  @Input() fechaCreacion: string;
  @Input() fechaActualizacion: string;

  getTrackingInfo() {
    const porcentaje = this.progreso ? this.progreso : -1;
    if (porcentaje === -1) {
      return {
        label: 'NUEVO',
        color: 'Yellow',
        icon: 'fa fa-plus-square',
        textColor: '#000'
      };
    }
    if (porcentaje >= 0 && porcentaje < 100) {
      return {
        label: 'EN_CURSO',
        color: 'Yellow',
        icon: 'fa fa-server',
        textColor: '#000'
      };
    }
    if (porcentaje === 100) {
      return {
        label: 'ACTIVO',
        color: '#9AB83A',
        icon: 'fa fa-check-circle',
        textColor: '#FFF'
      };
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/formWidgets/tracking.component.ts